import * as React from 'react';
const SvgSharing = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M122 122v-15.652h-15.652V122H122ZM69.826 17.652V2H54.174v15.652h15.652ZM54.174 122 62 106.348 69.826 122H54.174ZM17.652 122v-15.652H2V122h15.652ZM88.087 69.826v7.826c0 5.74 4.696 10.435 10.435 10.435h5.217c5.739 0 10.435 4.696 10.435 10.435v7.826M88.087 69.826v7.826c0 5.74-4.696 10.435-10.435 10.435h-5.217C66.695 88.087 62 92.783 62 98.522v7.826M35.913 69.826v7.826c0 5.74 4.696 10.435 10.435 10.435h5.217c5.74 0 10.435 4.696 10.435 10.435v7.826M35.913 69.826v7.826c0 5.74-4.695 10.435-10.435 10.435h-5.217c-5.74 0-10.435 4.696-10.435 10.435v7.826M88.087 54.174v-7.826c0-5.74 4.696-10.435 10.435-10.435h5.217c5.739 0 10.435-4.696 10.435-10.435v-7.826M88.087 54.174v-7.826c0-5.74-4.696-10.435-10.435-10.435h-5.217C66.695 35.913 62 31.217 62 25.478v-7.826"
      stroke="#000"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
    <path
      d="M35.913 54.174v-7.826c0-5.74 4.696-10.435 10.435-10.435h5.217c5.74 0 10.435-4.696 10.435-10.435v-7.826M35.913 54.174v-7.826c0-5.74-4.695-10.435-10.435-10.435h-5.217c-5.74 0-10.435-4.696-10.435-10.435v-7.826M114.174 17.652a7.826 7.826 0 1 0 0-15.652 7.826 7.826 0 0 0 0 15.652Z"
      stroke="#000"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
    <path
      d="M9.826 17.652A7.826 7.826 0 1 0 9.826 2a7.826 7.826 0 0 0 0 15.652ZM101.131 54.174H22.87v15.652h78.261V54.174Z"
      stroke="#000"
      strokeWidth={4}
      strokeMiterlimit={10}
    />
  </svg>
);
export default SvgSharing;
